var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "custom-container" }, [
    _c(
      "div",
      { staticClass: "table-container" },
      [
        _c("div", { staticClass: "title" }, [
          _vm._v("奶粉营销事业部2021年6月损益分析报表"),
        ]),
        _c(
          "vxe-table",
          { attrs: { border: "", align: "center", data: _vm.tableData } },
          [
            _c("vxe-table-column", {
              attrs: { field: "a", title: "", align: "left" },
            }),
            _c(
              "vxe-table-colgroup",
              { attrs: { title: "总计" } },
              [
                _c("vxe-table-column", {
                  attrs: { field: "b", title: "预算" },
                }),
                _c("vxe-table-column", {
                  attrs: { field: "c", title: "实际" },
                }),
              ],
              1
            ),
            _c(
              "vxe-table-colgroup",
              { attrs: { title: "直营" } },
              [
                _c("vxe-table-column", {
                  attrs: { field: "d", title: "预算" },
                }),
                _c("vxe-table-column", {
                  attrs: { field: "e", title: "实际" },
                }),
              ],
              1
            ),
            _c(
              "vxe-table-colgroup",
              { attrs: { title: "进销商" } },
              [
                _c("vxe-table-column", {
                  attrs: { field: "f", title: "预算" },
                }),
                _c("vxe-table-column", {
                  attrs: { field: "g", title: "实际" },
                }),
              ],
              1
            ),
            _c(
              "vxe-table-colgroup",
              { attrs: { title: "电商" } },
              [
                _c("vxe-table-column", {
                  attrs: { field: "h", title: "预算" },
                }),
                _c("vxe-table-column", {
                  attrs: { field: "i", title: "实际" },
                }),
              ],
              1
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }